// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentCounterpartyUserDetail {
    static getAttributeTypeMap() {
        return DigitalpaymentCounterpartyUserDetail.attributeTypeMap;
    }
}
DigitalpaymentCounterpartyUserDetail.discriminator = undefined;
DigitalpaymentCounterpartyUserDetail.additionalProperties = false;
DigitalpaymentCounterpartyUserDetail.attributeTypeMap = [
    {
        "name": "counterpartyUserName",
        "baseName": "counterpartyUserName",
        "type": "string"
    },
    {
        "name": "counterpartyUserAliasId",
        "baseName": "counterpartyUserAliasId",
        "type": "string"
    },
    {
        "name": "counterpartyUserEmailAddress",
        "baseName": "counterpartyUserEmailAddress",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentCounterpartyUserDetail.js.map